import { render, staticRenderFns } from "./DishStatisticFragment.vue?vue&type=template&id=35f0e597&scoped=true&"
import script from "./DishStatisticFragment.vue?vue&type=script&lang=js&"
export * from "./DishStatisticFragment.vue?vue&type=script&lang=js&"
import style0 from "./DishStatisticFragment.vue?vue&type=style&index=0&id=35f0e597&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f0e597",
  null
  
)

export default component.exports